import Repository from './repository'
import * as Sentry from '@sentry/vue'
const resource = '/event_archive_sections'

export default {
  async getEventArchiveSections (eventArchiveId) {
    try {
      const response = await Repository.get(resource, { params: { event_archive_id: eventArchiveId } })
      if (response) {
        return response.data.event_archive_sections
      }
      return null
    } catch (error) {
      Sentry.captureException(error)
    }
  }
}
